// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const Outgoing = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `Outgoing-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 18}
      height={size ?? 18}
      fill="none"
      viewBox="0 0 18 18"
      ref={ref}
      {...props}
    >
      <g stroke="currentColor" clipPath={`url(#${instanceId}-Outgoing_a)`}>
        <path d="M6.188 10.688h-4.5v-4.5" />
        <path strokeLinejoin="round" d="M15.75 12.938A6.75 6.75 0 0 0 4.227 8.165l-2.54 2.523" />
      </g>
      <defs>
        <clipPath id={`${instanceId}-Outgoing_a`}>
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(Outgoing);
export default ForwardRef;
